const group = {
  duplicate: 6000,
  not_found: 6001,
};

export default group;
